module.exports = __webpack_public_path__ + "components/flag/static/square/nr-09d5bf0a2b3b426335a5164ed5fe3d40.svg";